







































































import { Vue, Component, Prop } from 'vue-property-decorator';

import BasicMobileFullModal from '~/components/modals/BasicMobileFullModal.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';

@Component({
  components: { BasicMobileFullModal, CheckInput },
})
export default class LocalisationProvidersMobileModal extends Vue {
  @Prop(Array) providerTypes: [];
  @Prop(Boolean) respects: false;
}
